<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'500px'"
    :classDialog="'dialog-bhanh-doc-out'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <div class="">
        <h3 class="dialogTitle">Từ chối văn bản</h3>
        <el-form label-position="top" ref="form" :model="form" :rules="rules">
          <el-form-item label="Lý do từ chối" prop="content">
            <el-input
              v-model="form.content"
              type="textarea"
              rows="5"
              placeholder="_"
            />
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action margin-top-10">
        <el-button
          type="success"
          size="mini"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="tuChoi"
          :disabled="isProcessing"
        >
          <span>
            <i :class="[!isProcessing ? 'far fa-check-circle font-size__small' : 'el-icon-loading']"></i>
            &nbsp;Xác nhận
          </span>
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>
<script>
  import vbOutgoingProcessService from "../../../services/vbOutgoingProcessService";
  import attachmentService from "../../../services/attachmentService";
  import constants from "../../../constants";
  import {EventBus} from "../../../event-bus";

  export default {
    name: "DocOutTuChoi",

    props: ["docId", "outgoingProcessId", "isOpen", "listImageChange","is-assistant-sign"],
    components: {
      dialogTemplate: () => import("../../common/custom-dialog.vue")
    },
    data() {
      return {
        attachmentMetaId: null,
        listPageNumberChange: [],
        vbAttachmentId: null,
        imageExtractIds: [],
        form: {content: null},
        rules: {
          content: [
            {
              required: true,
              message: "Trường dữ liệu bắt buộc",
              trigger: "blur"
            }
          ]
        },
        isProcessing: false
      };
    },

    methods: {


      uploadImageDoc2() {
        attachmentService.uploadFileComment({
          vbAttachmentId: this.vbAttachmentId,
          imageExtractIds: this.imageExtractIds,
        })
          .then(res => {
            this.attachmentMetaId = res.data.id;
            this.submit();
          })
      },
      uploadImageDoc(index) {
        if (index === this.listImageChange.length) {
          this.uploadImageDoc2();
        } else {
          let item = this.listImageChange[index];
          attachmentService.uploadImageDoc({
            base64: item.base64.substring(item.base64.indexOf(",") + 1),
            vbAttachmentId: item.vbAttachmentId,
            pageNumber: item.pageNumber,
            objectType: constants.DOC_TYPE.VB_DI,
            objectId: this.docId,
          })
            .then(res => {
              this.listPageNumberChange.push(item.pageNumber);
              this.imageExtractIds.push(res.data.id);
              this.vbAttachmentId = item.vbAttachmentId;
              index += 1;
              this.uploadImageDoc(index)
            })
        }

      },

      submit() {
        let submitForm = {
          outgoingProcessId: this.outgoingProcessId,
          content: this.form.content,
          listAttachmentMetaIds: this.listAttachmentMetaIds,
          listPageNumberChange: this.listPageNumberChange,
          attachmentMetaId: this.attachmentMetaId,
          isAssistantSign: this.isAssistantSign
        };

        vbOutgoingProcessService
          .tuChoi(submitForm, this.docId)
          .then(() => {
            this.message(
              "Thông báo",
              "Từ chối văn bản thành công.",
              "success",
              3000
            );
            this.$emit("tuChoiSuccess");
            this.isProcessing = false;
            EventBus.$emit('loadCounting', '');
          })
          .catch(error => {
            this.commonHandleRequestError(error);
            this.isProcessing = false;
          });
      },

      tuChoi() {
        this.$refs.form.validate(valid => {
          if (!valid) return;
          this.isProcessing = true;
          if (this.listImageChange.length > 0) {
            this.listAttachmentMetaIds = [];
            this.listPageNumberChange = [];
            this.imageExtractIds = [];
            this.uploadImageDoc(0);
          } else this.submit();

        });
      }
    }
  }
  ;
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-out/components/DocOutTuChoi.vue